import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Slider as MuiSlider } from '@material-ui/core';
export const Slider = /*#__PURE__*/ forwardRef((props, ref)=>{
    return /*#__PURE__*/ _jsx(MuiSlider, _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
